<a [routerLink]="['/individuals', individualId]" class="h-100 d-flex align-items-center justify-content-between gap-2">
  <div class="name">{{ name }}</div>

  @if (individualId && verificationStatus == IndividualVerificationStatus.Verified && showIndividualVerification) {
    <i class="icon ic-verification-inverted-20 bg-green"></i>
  }
</a>
